







































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Filter } from "@/utils/decorator";
import moment from "moment";

@Component
export default class CustomTable extends Vue {
  @Prop({ default: () => [] }) data: any;
  @Prop({ default: () => [] }) columns: any;
  @Prop({ default: () => [] }) pagination: any;
  @Prop({ default: false }) showEdit?: boolean;
  @Prop({ default: false }) showRemove?: boolean;
  @Prop() documentType: any;
  @Prop() change: any;
  @Prop() edit: any;
  @Prop() remove: any;
  @Prop() rowClick: any;
  @Prop() toggle: any;
  @Prop() walletId: any;
  // @Prop() status: any;

  @Filter()
  dateFormat(date: Date) {
    return moment(date).format("yyyy-MM-DD HH:mm");
  }

  @Filter()
  stringBooleanFormat(value: string) {
    return value == "0" ? "필수" : value;
  }

  @Filter()
  emptyFormat(value: string) {
    return value ?? "-";
  }

  @Filter()
  numberFormat(value: string) {
    if (value == null) {
      return "-";
    }
    const regexp = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(regexp, ",");
  }

  @Filter()
  phoneFormat(value: string) {
    const regexp = /\B(?=(\d{4})+(?!\d))/g;
    return value.toString().replace(regexp, "-");
  }

  moveOn(page: number) {
    this.$emit("change", page);
  }

  // reception(record: any) {
  //   record.status = '1';
  //   // console.log(status);
  //   this.$emit("status", record);
  // }

  customRow(record: any) {
    return {
      props: {
        record,
      },
      on: {
        click: () => {
          this.$emit("rowClick", record);
        },
      },
    };
  }

  async toggleItem(record: any) {
    this.$emit("toggle", record);
  }

  editEvent(record: any) {
    this.$emit("edit", record);
  }

  sendConfirm(record: any) {
    this.$emit("confirm", record);
  }

  confirm(record: any) {
    this.$emit("remove", record);
  }
}
